/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AudioArrangementCreateRequest,
  AudioArrangementCreateTrackRequest,
  AudioArrangementDetail,
  AudioArrangementListParams,
  AudioArrangementRender202,
  ErrorResponse,
  PaginatedAudioArrangementListList,
  PatchedAudioArrangementUpdateRequest,
  TrackDetail,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자의 어레인지먼트 목록을 조회합니다.
 * @summary 어레인지먼트 목록 조회
 */
export const audioArrangementList = (
  params?: AudioArrangementListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedAudioArrangementListList>(
    { url: `/api/audio-arrangements/`, method: "GET", params, signal },
    options,
  );
};

export const getAudioArrangementListQueryKey = (
  params?: AudioArrangementListParams,
) => {
  return [`/api/audio-arrangements/`, ...(params ? [params] : [])] as const;
};

export const getAudioArrangementListQueryOptions = <
  TData = Awaited<ReturnType<typeof audioArrangementList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: AudioArrangementListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAudioArrangementListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof audioArrangementList>>
  > = ({ signal }) => audioArrangementList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof audioArrangementList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AudioArrangementListQueryResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementList>>
>;
export type AudioArrangementListQueryError = ErrorType<ErrorResponse>;

export function useAudioArrangementList<
  TData = Awaited<ReturnType<typeof audioArrangementList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | AudioArrangementListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof audioArrangementList>>,
          TError,
          Awaited<ReturnType<typeof audioArrangementList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAudioArrangementList<
  TData = Awaited<ReturnType<typeof audioArrangementList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: AudioArrangementListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof audioArrangementList>>,
          TError,
          Awaited<ReturnType<typeof audioArrangementList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAudioArrangementList<
  TData = Awaited<ReturnType<typeof audioArrangementList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: AudioArrangementListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 어레인지먼트 목록 조회
 */

export function useAudioArrangementList<
  TData = Awaited<ReturnType<typeof audioArrangementList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: AudioArrangementListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAudioArrangementListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 새 어레인지먼트를 생성합니다. clips 최소 1개 필수.
 * @summary 어레인지먼트 생성
 */
export const audioArrangementCreate = (
  audioArrangementCreateRequest: BodyType<AudioArrangementCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AudioArrangementDetail>(
    {
      url: `/api/audio-arrangements/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: audioArrangementCreateRequest,
      signal,
    },
    options,
  );
};

export const getAudioArrangementCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementCreate>>,
    TError,
    { data: BodyType<AudioArrangementCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementCreate>>,
  TError,
  { data: BodyType<AudioArrangementCreateRequest> },
  TContext
> => {
  const mutationKey = ["audioArrangementCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementCreate>>,
    { data: BodyType<AudioArrangementCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return audioArrangementCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementCreate>>
>;
export type AudioArrangementCreateMutationBody =
  BodyType<AudioArrangementCreateRequest>;
export type AudioArrangementCreateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 어레인지먼트 생성
 */
export const useAudioArrangementCreate = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementCreate>>,
      TError,
      { data: BodyType<AudioArrangementCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementCreate>>,
  TError,
  { data: BodyType<AudioArrangementCreateRequest> },
  TContext
> => {
  const mutationOptions = getAudioArrangementCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 어레인지먼트 상세 정보 (소스 버전 메타데이터 포함)를 조회합니다.
 * @summary 어레인지먼트 상세 조회
 */
export const audioArrangementRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AudioArrangementDetail>(
    { url: `/api/audio-arrangements/${id}/`, method: "GET", signal },
    options,
  );
};

export const getAudioArrangementRetrieveQueryKey = (id?: string) => {
  return [`/api/audio-arrangements/${id}/`] as const;
};

export const getAudioArrangementRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof audioArrangementRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAudioArrangementRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof audioArrangementRetrieve>>
  > = ({ signal }) => audioArrangementRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof audioArrangementRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AudioArrangementRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementRetrieve>>
>;
export type AudioArrangementRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useAudioArrangementRetrieve<
  TData = Awaited<ReturnType<typeof audioArrangementRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof audioArrangementRetrieve>>,
          TError,
          Awaited<ReturnType<typeof audioArrangementRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAudioArrangementRetrieve<
  TData = Awaited<ReturnType<typeof audioArrangementRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof audioArrangementRetrieve>>,
          TError,
          Awaited<ReturnType<typeof audioArrangementRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAudioArrangementRetrieve<
  TData = Awaited<ReturnType<typeof audioArrangementRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 어레인지먼트 상세 조회
 */

export function useAudioArrangementRetrieve<
  TData = Awaited<ReturnType<typeof audioArrangementRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof audioArrangementRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAudioArrangementRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 어레인지먼트를 수정합니다. rendering 중에는 수정 불가.
 * @summary 어레인지먼트 수정
 */
export const audioArrangementPartialUpdate = (
  id: string,
  patchedAudioArrangementUpdateRequest: BodyType<PatchedAudioArrangementUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AudioArrangementDetail>(
    {
      url: `/api/audio-arrangements/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedAudioArrangementUpdateRequest,
    },
    options,
  );
};

export const getAudioArrangementPartialUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedAudioArrangementUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedAudioArrangementUpdateRequest> },
  TContext
> => {
  const mutationKey = ["audioArrangementPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementPartialUpdate>>,
    { id: string; data: BodyType<PatchedAudioArrangementUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return audioArrangementPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementPartialUpdate>>
>;
export type AudioArrangementPartialUpdateMutationBody =
  BodyType<PatchedAudioArrangementUpdateRequest>;
export type AudioArrangementPartialUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 어레인지먼트 수정
 */
export const useAudioArrangementPartialUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedAudioArrangementUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedAudioArrangementUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getAudioArrangementPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 오디오 어레인지먼트 CRUD + render + create-track.
 * @summary 어레인지먼트 삭제
 */
export const audioArrangementDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/audio-arrangements/${id}/`, method: "DELETE" },
    options,
  );
};

export const getAudioArrangementDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["audioArrangementDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return audioArrangementDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementDestroy>>
>;

export type AudioArrangementDestroyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 어레인지먼트 삭제
 */
export const useAudioArrangementDestroy = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAudioArrangementDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 완료된 어레인지먼트의 렌더링 결과를 새 Track + TrackVersion으로 생성합니다.
 * @summary 렌더링 결과를 새 트랙으로 등록
 */
export const audioArrangementCreateTrack = (
  id: string,
  audioArrangementCreateTrackRequest: BodyType<AudioArrangementCreateTrackRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/audio-arrangements/${id}/create-track/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: audioArrangementCreateTrackRequest,
      signal,
    },
    options,
  );
};

export const getAudioArrangementCreateTrackMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementCreateTrack>>,
    TError,
    { id: string; data: BodyType<AudioArrangementCreateTrackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementCreateTrack>>,
  TError,
  { id: string; data: BodyType<AudioArrangementCreateTrackRequest> },
  TContext
> => {
  const mutationKey = ["audioArrangementCreateTrack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementCreateTrack>>,
    { id: string; data: BodyType<AudioArrangementCreateTrackRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return audioArrangementCreateTrack(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementCreateTrackMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementCreateTrack>>
>;
export type AudioArrangementCreateTrackMutationBody =
  BodyType<AudioArrangementCreateTrackRequest>;
export type AudioArrangementCreateTrackMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 렌더링 결과를 새 트랙으로 등록
 */
export const useAudioArrangementCreateTrack = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementCreateTrack>>,
      TError,
      { id: string; data: BodyType<AudioArrangementCreateTrackRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementCreateTrack>>,
  TError,
  { id: string; data: BodyType<AudioArrangementCreateTrackRequest> },
  TContext
> => {
  const mutationOptions =
    getAudioArrangementCreateTrackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Celery 태스크를 트리거하여 어레인지먼트를 렌더링합니다.
 * @summary 어레인지먼트 렌더링 시작
 */
export const audioArrangementRender = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AudioArrangementRender202>(
    { url: `/api/audio-arrangements/${id}/render/`, method: "POST", signal },
    options,
  );
};

export const getAudioArrangementRenderMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof audioArrangementRender>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof audioArrangementRender>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["audioArrangementRender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof audioArrangementRender>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return audioArrangementRender(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AudioArrangementRenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof audioArrangementRender>>
>;

export type AudioArrangementRenderMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 어레인지먼트 렌더링 시작
 */
export const useAudioArrangementRender = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof audioArrangementRender>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof audioArrangementRender>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAudioArrangementRenderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
